export default {
      id: "i-main-investments-01-usage",
      viewBox: "0 0 210 110",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-investments-01",
      toString: function () {
        return this.url;
      }
    }